export default __webpack_public_path__ + "static/media/SunnySide.bc2317f1.png";